/* Adorle Independent. Original storefront implementation, no theme framework. */
(() => {
  'use strict';
  const cfg = window.Adorle || {};
  const root = (cfg.root || '/').replace(/\/?$/, '/');
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const report = text => { const node = $('#StoreStatus'); if (node) node.textContent = text; };
  let cartBusy = false;
  const dialogTriggers = new WeakMap();
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    $$('dialog[open]').forEach(closeDialog);
    dialogTriggers.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    if(dialog.id==='MobileMenu') $$('[aria-controls="MobileMenu"]').forEach(n=>n.setAttribute('aria-expanded','true'));
    document.documentElement.classList.add('dialog-open');
  }
  function closeDialog(dialog) {
    dialog.close();
    if(dialog.id==='MobileMenu') $$('[aria-controls="MobileMenu"]').forEach(n=>n.setAttribute('aria-expanded','false'));
    if (!$('dialog[open]')) document.documentElement.classList.remove('dialog-open');
  }
  $$('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      if(dialog.id==='MobileMenu') $$('[aria-controls="MobileMenu"]').forEach(n=>n.setAttribute('aria-expanded','false'));
      if (!$('dialog[open]')) document.documentElement.classList.remove('dialog-open');
      const trigger = dialogTriggers.get(dialog);
      if (trigger?.isConnected) trigger.focus({preventScroll:true});
    });
    dialog.addEventListener('click', e => { if (e.target === dialog) { const b=dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) closeDialog(dialog); } });
  });
  function setProductBusy(el, busy) {
    el.setAttribute('aria-busy', String(busy));
    $$('button[type="submit"], .add-button',el).forEach(b => {
      b.disabled = busy || el.dataset.variantAvailable !== 'true';
    });
  }
  function copyPreviewParams(url) {
    const current = new URL(location.href);
    ['preview_theme_id','_fd','pb'].forEach(k => { if(current.searchParams.has(k)) url.searchParams.set(k,current.searchParams.get(k)); });
    return url;
  }
  const variantRequests = new WeakMap();
  async function changeVariant(el, control) {
    const selected = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
    const alternate = selected?.dataset.productUrl;
    if (alternate && new URL(alternate,location.origin).pathname !== new URL(el.dataset.productUrl,location.origin).pathname) {
      location.assign(copyPreviewParams(new URL(alternate,location.origin)).href); return;
    }
    variantRequests.get(el)?.abort();
    const controller = new AbortController(); variantRequests.set(el,controller);
    const values = $$('[data-option-value]:checked, [data-option-select]',el).map(input=>input.value);
    const url = copyPreviewParams(new URL(el.dataset.productPage === 'true' ? el.dataset.productUrl : location.pathname,location.origin));
    url.searchParams.set('section_id',el.dataset.sectionId);
    url.searchParams.set('option_values',values.join(','));
    const plan = $('[name="selling_plan"]',el)?.value;
    if (plan) url.searchParams.set('selling_plan',plan);
    const qty = $('input[name="quantity"]',el)?.value;
    const focusName=control.name, focusValue=control.value;
    setProductBusy(el,true); const error = $('[data-product-error]',el); if(error) error.textContent='';
    try {
      const response=await fetch(url,{signal:controller.signal}); if(!response.ok) throw new Error('variant response');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=$('[data-product]',doc); if(!next || next.dataset.sectionId!==el.dataset.sectionId) throw new Error('missing product');
      $$('[data-refresh]',el).forEach(part=>{
        const replacement=$$('[data-refresh]',next).find(n=>n.dataset.refresh===part.dataset.refresh);
        if(replacement) part.innerHTML=replacement.innerHTML;
      });
      el.dataset.variantId=next.dataset.variantId || '';
      el.dataset.variantAvailable=next.dataset.variantAvailable || 'false';
      el.dataset.featuredMedia=next.dataset.featuredMedia || '';
      const hidden=$('[data-product-form] input[name="id"]',el);
      hidden.value=el.dataset.variantId; hidden.disabled=el.dataset.variantAvailable!=='true';
      const quantity=$('input[name="quantity"]',el);
      if(quantity && qty) { const min=Number(quantity.min)||1,step=Number(quantity.step)||1,max=Number(quantity.max)||Infinity; quantity.value=String(Math.min(max,Math.max(min,min+Math.floor((Number(qty)-min)/step)*step))); }
      if(el.dataset.productPage==='true') {
        const nextURL=new URL(location.href);nextURL.searchParams.delete('option_values');
        if(el.dataset.variantId) nextURL.searchParams.set('variant',el.dataset.variantId);else {nextURL.searchParams.delete('variant');nextURL.searchParams.set('option_values',values.join(','));}
        if(plan) nextURL.searchParams.set('selling_plan',plan);else nextURL.searchParams.delete('selling_plan');
        history.replaceState({},'',nextURL);
      }
      if(el.dataset.featuredMedia) selectMedia($('[data-gallery]',el),el.dataset.featuredMedia);
      $$('[data-payment-quantity]',el).forEach(n=>n.value=quantity?.value||'1');
      const focus=$$('[data-option-value], [data-option-select], [name="selling_plan"]',el).find(n=>n.name===focusName && (n.tagName==='SELECT'||n.value===focusValue));
      focus?.focus({preventScroll:true});
      setProductBusy(el,false);
      window.Shopify?.PaymentButton?.init();
      el.dispatchEvent(new CustomEvent('adorle:variant-change',{bubbles:true,detail:{variantId:el.dataset.variantId}}));
    } catch(e) {
      if(e.name==='AbortError') return;
      // Keep purchase disabled: old variant must never be sold under a new selection.
      if(error) error.textContent=cfg.strings.variantError;
      el.dataset.variantAvailable='false';
      const hidden=$('[data-product-form] input[name="id"]',el);if(hidden)hidden.disabled=true;
      el.setAttribute('aria-busy','false');
    }
  }
  function selectMedia(gallery,id) {
    if(!gallery) return;
    const slides=$$('[data-media-id]',gallery),index=slides.findIndex(s=>s.dataset.mediaId===String(id));
    if(index<0)return;
    const track=$('[data-gallery-track]',gallery),slide=slides[index];
    track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:'auto'});
    updateGallery(gallery,index);
  }
  function updateGallery(gallery,index) {
    const slides=$$('[data-media-id]',gallery),current=slides[index];if(!current)return;
    $$('[data-media-target]',gallery).forEach(b=>b.setAttribute('aria-current',String(b.dataset.mediaTarget===current.dataset.mediaId)));
    const pos=$('[data-gallery-position]',gallery);if(pos)pos.textContent=`${index+1} / ${slides.length}`;
    slides.forEach((s,i)=>{if(i!==index)$$('video',s).forEach(v=>v.pause());});
  }
  function cartError(text) {const node=$('[data-cart-error]', $('#CartDrawer'));if(node)node.textContent=text;report(text);}
  function lockCart(busy) {
    cartBusy=busy; const drawer=$('#CartDrawer');if(!drawer)return;
    drawer.setAttribute('aria-busy',String(busy));
    $$('button:not([data-close-dialog]),input,textarea',drawer).forEach(n=>n.disabled=busy);
  }
  function renderCart(html) {
    if(!html) return false;
    const doc=new DOMParser().parseFromString(html,'text/html'),panel=$('[data-cart-panel]',doc),target=$('#CartDrawer [data-cart-panel]');
    if(!panel||!target)return false;
    target.replaceWith(panel);$$('[data-cart-count]').forEach(n=>n.textContent=panel.dataset.count);
    report(`${panel.dataset.count} ${document.documentElement.lang==='fi'?'tuotetta':'items'}`);
    initTimers();return true;
  }
  async function addToCart(form,trigger) {
    if(form.dataset.busy==='true'||cartBusy)return;
    const product=form.closest('[data-product]'),error=$('[data-product-error]',product||form);
    if(product && (product.getAttribute('aria-busy')==='true' || product.dataset.variantAvailable!=='true'))return;
    form.dataset.busy='true'; if(error)error.textContent='';
    const data=new FormData(form);data.set('sections','cart-content');data.set('sections_url',location.pathname);
    // FormData must be collected before controls are disabled.
    const buttons=product?$$(`[form="${form.id}"]`,product).filter(n=>n.tagName==='BUTTON'):$$('button',form);
    buttons.forEach(b=>b.disabled=true);lockCart(true);
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||result.message||cfg.strings.error);
      // Show the cart immediately after Shopify confirms the item was added.
      // Refresh its contents while the drawer is already visible.
      const cartDialog=$('#CartDrawer');
      if(cartDialog && typeof cartDialog.showModal==='function') openDialog(cartDialog,trigger);
      let rendered=renderCart(result.sections?.['cart-content']);
      // Shopify may omit bundled sections when sections_url is unavailable in preview.
      // Fetch the drawer section independently rather than navigating to /cart (404 in some draft previews).
      if(!rendered) {
        const sectionResponse=await fetch(root+'?section_id=cart-content',{headers:{Accept:'text/html'}});
        if(sectionResponse.ok) rendered=renderCart(await sectionResponse.text());
      }
      if(!rendered) {
        // Keep the customer on the product page and show an actionable error.
        throw new Error(cfg.strings.cartError);
      }
      report(cfg.strings.added);openDialog($('#CartDrawer'),trigger);
      document.dispatchEvent(new CustomEvent('adorle:cart-update',{detail:result}));
    } catch(e) {if(error)error.textContent=e instanceof TypeError?cfg.strings.cartError:e.message;}
    finally {form.dataset.busy='false';lockCart(false);buttons.forEach(b=>b.disabled=product?(product.dataset.variantAvailable!=='true'||product.getAttribute('aria-busy')==='true'):false);}
  }
  async function changeCart(key,quantity) {
    if(cartBusy)return;lockCart(true);
    try {
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['cart-content'],sections_url:location.pathname})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||cfg.strings.error);
      if(!renderCart(result.sections?.['cart-content'])) {
        const sectionResponse=await fetch(root+'?section_id=cart-content',{headers:{Accept:'text/html'}});
        if(!sectionResponse.ok || !renderCart(await sectionResponse.text())) throw new Error(cfg.strings.cartError);
      }
      document.dispatchEvent(new CustomEvent('adorle:cart-update',{detail:result}));
    }catch(e){cartError(e instanceof TypeError?cfg.strings.cartError:e.message);}
    finally{lockCart(false);}
  }
  async function saveNote(input) {
    if(cartBusy)return;lockCart(true);
    try {const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:input.value})});if(!response.ok)throw new Error();}
    catch {cartError(cfg.strings.error);}
    finally{lockCart(false);}
  }
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(form.matches('[data-product-form], [data-quick-add]')) {e.preventDefault();addToCart(form,e.submitter);}
    if(form.matches('[data-drawer-form]') && cartBusy)e.preventDefault();
    if(form.dataset.confirm && !confirm(form.dataset.confirm))e.preventDefault();
  });
  document.addEventListener('change',e=>{
    const node=e.target;
    if(node.matches('[data-option-value], [data-option-select], [name="selling_plan"]'))changeVariant(node.closest('[data-product]'),node);
    if(node.matches('input[name="quantity"]') && node.closest('[data-product]')) { $$('[data-payment-quantity]',node.closest('[data-product]')).forEach(n=>n.value=node.value); }
    if(node.matches('[data-cart-quantity]')) {if(node.checkValidity())changeCart(node.dataset.key,Math.max(0,Number(node.value)));else node.reportValidity();}
    if(node.matches('[data-cart-note]'))saveNote(node);
    if(node.matches('[data-country-select]'))updateProvince(node,false);
  });
  document.addEventListener('click',e=>{
    const button=e.target.closest('button,a');if(!button)return;
    if(button.matches('#MobileMenu a')) closeDialog($('#MobileMenu'));
    if(button.hasAttribute('data-ticker-toggle')) { const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.closest('.brand-ticker').classList.toggle('is-paused',paused);button.textContent=paused?'▶':'Ⅱ'; }
    if(button.hasAttribute('data-close-dialog'))closeDialog(button.closest('dialog'));
    if(button.dataset.openDialog)openDialog(document.getElementById(button.dataset.openDialog),button);
    if(button.hasAttribute('data-open-cart')) {const cartDialog=$('#CartDrawer');if(cartDialog && typeof cartDialog.showModal==='function'){e.preventDefault();openDialog(cartDialog,button);}}
    if(button.hasAttribute('data-cart-remove')) {e.preventDefault();changeCart(button.dataset.key,0);}
    if(button.dataset.quantityStep) {const input=$('input',button.closest('.quantity-control'));try{Number(button.dataset.quantityStep)>0?input.stepUp():input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}catch{}}
    if(button.dataset.mediaTarget)selectMedia(button.closest('[data-gallery]'),button.dataset.mediaTarget);
    if(button.dataset.galleryStep) {const g=button.closest('[data-gallery]'),slides=$$('[data-media-id]',g),selected=$('[aria-current="true"]',g);let i=slides.findIndex(s=>s.dataset.mediaId===selected?.dataset.mediaTarget);i=Math.max(0,Math.min(slides.length-1,i+Number(button.dataset.galleryStep)));selectMedia(g,slides[i]?.dataset.mediaId);}
    if(button.dataset.zoom) {const img=$('#ZoomImage');img.src=button.dataset.zoom;img.alt=$('img',button)?.alt||'';openDialog($('#MediaZoom'),button);}
    if(button.dataset.slideStep) {const track=$('[data-slides-track]',button.closest('[data-slideshow]'));track.scrollBy({left:track.clientWidth*Number(button.dataset.slideStep),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    if(button.hasAttribute('data-back-top')) {e.preventDefault();window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  });
  const searchState=new WeakMap();
  document.addEventListener('input',e=>{
    const input=e.target;if(!input.matches('[data-search-input]'))return;
    const form=input.closest('form'),results=$('[data-search-results]',form);const previous=searchState.get(input);clearTimeout(previous?.timer);previous?.controller?.abort();
    const controller=new AbortController();const query=input.value.trim();
    if(query.length<2){results.hidden=true;input.setAttribute('aria-expanded','false');searchState.delete(input);return;}
    const timer=setTimeout(async()=>{
      try {
        const url=new URL(root+'search/suggest',location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','5');url.searchParams.set('section_id','predictive-search');
        const res=await fetch(url,{signal:controller.signal});if(!res.ok)throw new Error();
        const doc=new DOMParser().parseFromString(await res.text(),'text/html'),content=$('[data-predictive-content]',doc);
        if(content&&input.value.trim()===query){results.replaceChildren(content);results.hidden=false;input.setAttribute('aria-expanded','true');}
      }catch(error){if(error.name!=='AbortError'){results.hidden=true;input.setAttribute('aria-expanded','false');}}
    },250);searchState.set(input,{timer,controller});
  });
  document.addEventListener('keydown',e=>{
    const form=e.target.closest('[data-search-form]');if(!form)return;
    const results=$('[data-search-results]',form),input=$('[data-search-input]',form),links=$$('a',results);
    if(e.key==='Escape'){results.hidden=true;input.setAttribute('aria-expanded','false');input.focus();}
    if(!results.hidden && (e.key==='ArrowDown'||e.key==='ArrowUp')){e.preventDefault();const index=links.indexOf(document.activeElement),next=e.key==='ArrowDown'?Math.min(index+1,links.length-1):Math.max(index-1,0);links[next]?.focus();}
  });
  document.addEventListener('click',e=>{if(!e.target.closest('[data-search-form]'))$$('[data-search-results]').forEach(n=>{n.hidden=true;$('[data-search-input]',n.closest('form'))?.setAttribute('aria-expanded','false');});});
  function updateProvince(country,initial) {
    const form=country.closest('form'),province=$('[data-province-select]',form),wrap=$('[data-province-wrap]',form);if(!province)return;
    if(initial&&country.dataset.default)country.value=country.dataset.default;
    let provinces=[];try{provinces=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');}catch{}
    province.replaceChildren(...provinces.map(([value,label])=>new Option(label,value)));
    wrap.hidden=provinces.length===0;province.disabled=provinces.length===0;
    if(initial&&province.dataset.default)province.value=province.dataset.default;
  }
  let timerInterval;
  function initTimers() {
    clearInterval(timerInterval);const timer=$('[data-session-timer]');if(!timer)return;
    let end;const key='adorle-cart-session';try{end=Number(sessionStorage.getItem(key));if(!end){end=Date.now()+Number(timer.dataset.sessionTimer)*60000;sessionStorage.setItem(key,String(end));}}catch{end=Date.now()+Number(timer.dataset.sessionTimer)*60000;}
    const tick=()=>{const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));const output=$('[data-timer-value]',timer);if(output)output.textContent=`${Math.floor(remaining/60)}:${String(remaining%60).padStart(2,'0')}`;if(!remaining){timer.textContent=cfg.strings.expired;clearInterval(timerInterval);}};
    tick();timerInterval=setInterval(tick,1000);
  }
  function initialize(scope=document) {
    $$('[data-gallery]',scope).forEach(g=>{
      if(g.dataset.initialized)return;g.dataset.initialized='true';const track=$('[data-gallery-track]',g);
      let scheduled=false;track.addEventListener('scroll',()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;const slides=$$('[data-media-id]',g);if(!slides.length)return;const left=track.getBoundingClientRect().left;const distances=slides.map(s=>Math.abs(s.getBoundingClientRect().left-left));updateGallery(g,distances.indexOf(Math.min(...distances)));});},{passive:true});
      const initial=$('[data-selected-media]',g);if(initial)requestAnimationFrame(()=>selectMedia(g,initial.dataset.mediaId));
    });
    $$('[data-product]',scope).forEach(product=>{
      if(product.dataset.initialized)return;product.dataset.initialized='true';const sticky=$('[data-sticky-buy]',product),buy=$('.add-button',product);
      if(sticky&&buy){
        // Check the actual buy button on every scroll. IntersectionObserver alone
        // can miss the transition when the product form is below a sticky header.
        let pending=false;
        const updateSticky=()=>{
          pending=false;
          const rect=buy.getBoundingClientRect();
          const ticker=$('.brand-ticker');
          const header=$('.site-header[data-sticky="true"]');
          const coveredTop=(ticker?.getBoundingClientRect().height||0)+(header?.getBoundingClientRect().height||0);
          sticky.hidden=rect.bottom>coveredTop;
        };
        const scheduleSticky=()=>{if(!pending){pending=true;requestAnimationFrame(updateSticky);}};
        window.addEventListener('scroll',scheduleSticky,{passive:true});
        window.addEventListener('resize',scheduleSticky,{passive:true});
        product._stickyCleanup=()=>{window.removeEventListener('scroll',scheduleSticky);window.removeEventListener('resize',scheduleSticky);};
        scheduleSticky();
      }
    });
    $$('[data-recommendations]',scope).forEach(async el=>{
      if(el.dataset.loaded)return;el.dataset.loaded='true';
      try{const res=await fetch(el.dataset.url);if(!res.ok)return;const doc=new DOMParser().parseFromString(await res.text(),'text/html'),next=$('[data-recommendations]',doc);if(next?.querySelector('.product-grid'))el.innerHTML=next.innerHTML;else el.hidden=true;}catch{el.hidden=true;}
    });
    $$('[data-country-select]',scope).forEach(c=>updateProvince(c,true));
    $$('form .errors',scope).forEach(err=>{const details=err.closest('details');if(details)details.open=true;});
    initTimers();
  }
  document.addEventListener('shopify:section:load',e=>initialize(e.target));
  document.addEventListener('shopify:section:unload',e=>$$('[data-product]',e.target).forEach(p=>{p._stickyCleanup?.();p._observer?.disconnect();variantRequests.get(p)?.abort();}));
  document.addEventListener('shopify:block:select',e=>{const details=$('details',e.target);if(details)details.open=true;const slide=e.target.closest('.hero-slide');if(slide)slide.scrollIntoView({block:'nearest',inline:'start'});});
  initialize();
  if ($('model-viewer') && window.Shopify?.loadFeatures) { window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:error=>{if(!error)$$('model-viewer').forEach(model=>new window.Shopify.ModelViewerUI(model));}}]); }
  window.addEventListener('pageshow',e=>{if(e.persisted)fetch(root+'?section_id=cart-content').then(r=>r.text()).then(renderCart).catch(()=>{});});
})();
